import { AttioSortDirection } from 'dashboard409a/common/constants/analyst-dashboard';

interface SortState {
  sortBy: string;
  sortOrder: AttioSortDirection;
}

/**
 * Gets the initial sort order from localStorage or returns defaults
 * @param localStorageKey - The key to use in localStorage
 * @param defaultOrderBy - Default orderBy value if not found in localStorage
 * @param defaultOrder - Default order value if not found in localStorage
 * @returns An object with sortBy and sortOrder
 */
export const getInitialSortFromStorage = (
  localStorageKey: string,
  defaultOrderBy: string,
  defaultOrder: AttioSortDirection
): SortState => {
  const localSort = localStorage.getItem(localStorageKey);
  
  if (localSort) {
    try {
      const parsed = JSON.parse(localSort);
      return {
        sortBy: parsed.sortBy || defaultOrderBy,
        sortOrder: parsed.sortOrder || defaultOrder,
      };
    } catch {
      // If parsing fails, return defaults
      return {
        sortBy: defaultOrderBy,
        sortOrder: defaultOrder,
      };
    }
  }
  
  return {
    sortBy: defaultOrderBy,
    sortOrder: defaultOrder,
  };
};

